export const initMenu = () => {
    // const menu = document.querySelector('.header__menu');

    // menu.addEventListener('click', () => {
    //     document.body.classList.toggle('layout--menu-open');
    // });
};
